import { Injectable } from '@angular/core';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';

@Injectable()
export class AuthStorage implements AbstractSecurityStorage {
  read(key: string) {
    const item = localStorage.getItem(key);
    {
      // maintain backwards compatibility for old data saved by the previous version of write()
      // the old write() used to stringify before saving
      // BrowserStorageService in oidc already does stringify & parse thus it's redundant to do this in AuthStorage
      // as BrowserStorageService was already stringifying we need to look for double stringified data
      if (item?.startsWith('"{\\"')) {
        return JSON.parse(item) as string;
      }
    }
    return item;
  }
  write(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
  remove(key: string): void {
    localStorage.removeItem(key);
  }
  clear(): void {
    localStorage.clear();
  }
}
